import Lottie from 'lottie-react';
import animationData from './loader.json';
import { Grid } from '@mui/material';

interface ILoaderProps {
  width?: string;
}

export const Loader = ({ width }: ILoaderProps) => {
  return (
    <Grid sx={{ maxWidth: width || '220px', margin: '0 auto' }}>
      <Lottie animationData={animationData} loop />
    </Grid>
  );
};
